// Packages
import PropTypes from 'prop-types'

// Components
import UserForm from 'modules/Users/components/Form';

// Other
import useApi from 'hooks/useApi';

const UserEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/users/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'User updated!')) {

            onSubmit();
        }
    }

    return(
        <UserForm 
            errors={errors} 
            item={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

UserEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

UserEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default UserEditScreen;